<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><k-dialog v-model="dialog_open" persistent max-width="800px" aria-labelledby="satchel-admin-user-edit-title" @keydown.esc="cancel_clicked"><k-card>
	<k-card-title>
		<div id="satchel-admin-user-edit-title">{{new_user ? 'Create' : 'Edit'}} User <b class="mx-1">{{user.email}}</b> {{(new_user) ? '' : ('(' + user.last_name + ', ' + user.first_name + ')')}}</div>
		<k-spacer></k-spacer>
		<k-btn icon accessible-label="Open user editing help" @click="show_help" color="light-blue"><k-icon large>fas fa-info-circle</k-icon></k-btn>
	</k-card-title>
	<k-card-text style="color:#000;">
		<div class="d-flex align-center mt-3">
			<k-text-field class="mr-1" dense outlined hide-details label="First Name" v-model="first_name"></k-text-field>
			<k-text-field class="ml-1" dense outlined hide-details label="Last Name" v-model="last_name"></k-text-field>
		</div>
		<div v-if="instance_has_organizations" class="d-flex align-center justify-center mt-3">
			<k-text-field class="mr-2" dense outlined hide-details label="Organization" v-model="organization"></k-text-field>
			<div style="width:180px">
				<v-select v-model="organization_type" :items="organization_types" label="Organization Type" outlined dense hide-details append-icon="fas fa-caret-down"></v-select>
			</div>
			<k-text-field class="ml-2" dense outlined hide-details label="Job Title" v-model="org_job_title"></k-text-field>
		</div>
		<div v-if="instance_has_organizations&&registration_reason" class="mt-3 pa-2 grey lighten-3">
			<b>Reason user gave for registration:</b> {{registration_reason}}
		</div>
		<div class="d-flex align-center justify-center mt-3">
			<k-text-field v-if="!use_oidc_login" class="mr-1" dense outlined hide-details label="Enter a new password (optional)" v-model="password" autocomplete="new-password"></k-text-field>
			<k-tooltip bottom><template v-slot:activator="{on}"><k-btn v-on="on" v-if="!use_oidc_login" x-small fab color="primary" class="mr-3" accessible-label="Generate random password" @click="generate_random_password"><k-icon small>fas fa-shuffle</k-icon></k-btn></template>Generate random password</k-tooltip>
			<k-select class="ml-1" style="flex:0 0 340px" outlined hide-details v-model="system_role" :items="system_role_options" label="System Role" solo hide-details dense></k-select>
		</div>
		<div v-if="!use_oidc_login&&!new_user" class="mt-3 d-flex">
			<k-btn small color="secondary" class="k-tight-btn" @click="send_password_reset"><k-icon small class="mr-2">fas fa-envelope</k-icon> Send One-Time Sign-In Link…</k-btn>
			<k-spacer/>
			<div v-if="instance_has_subdomains" class="d-flex align-center">
				<div>User can create frameworks for subdomain:</div>
				<div style="width:100px" class="ml-2">
					<k-text-field dense outlined hide-details label="" v-model="allow_to_create_frameworks_for_category"></k-text-field>
				</div>
			</div>

			<!-- this can be deleted -->
			<!-- <v-checkbox class="mt-0 pt-0" hide-details off-icon="far fa-square" on-icon="fas fa-check-square"
				v-if="viewing_subdomain"
				v-model="allow_to_create_frameworks" 
				:disabled="system_role=='admin'||system_role=='editor'"
				:label="'Allow user to create frameworks'" 
			></v-checkbox> -->

		</div>
		<div v-if="instance_uses_category_access">
			<div class="d-flex align-center mt-6">
				<v-spacer/>
				<div style="flex:0 0 auto" class="text-right pr-3">Framework categories for download/API access:</div>
				<div style="flex:0 0 45%">
					<v-select v-model="category_access" :items="category_filter_items" label="Framework categor(ies)" multiple outlined dense hide-details append-icon="fas fa-caret-down"></v-select>
				</div>
				<v-spacer/>
			</div>
			<div v-if="category_access_request_display" class="d-flex align-center mt-4">
				<v-spacer/>
				<div class="mr-3">User has requested access to: <nobr><b>{{category_access_request_display}}</b></nobr></div>
				<k-btn v-if="category_access_requested" class="mr-3" small color="primary" @click="grant_category_access"><k-icon small class="mr-2">fas fa-seal</k-icon> Grant Access</k-btn>
				<k-btn v-if="category_access_requested" class="mr-3" small :color="category_access_request_denied ? 'secondary' : 'red'" dark @click="deny_category_access"><k-icon small class="mr-2">fas fa-ban</k-icon>{{category_access_request_denied ? 'Access Denied' : 'Deny Access'}}</k-btn>
				<k-btn v-if="!category_access_requested" small color="secondary" :href="category_access_email_href"><k-icon small class="mr-2">fas fa-envelope</k-icon> Email User</k-btn>
				<v-spacer/>
			</div>
		</div>

	</k-card-text>
	<k-card-actions class="pl-4 pr-4 pb-4">
		<k-btn v-if="!use_oidc_login&&user.user_id!=0" color="red" dark @click="$emit('user_deleted')"><k-icon small class="mr-2">fas fa-trash-alt</k-icon> Delete User</k-btn>
		<k-spacer></k-spacer>
		<k-btn color="secondary" @click="cancel_clicked" class="mr-1"><k-icon small class="mr-2">fas fa-times</k-icon> Cancel</k-btn>
		<k-btn color="primary" @click="save_edits" class="k-tight-btn"><k-icon small class="mr-2">fas fa-check</k-icon> {{new_user ? 'Create user and send invitation email' : 'Save Changes'}}</k-btn>
	</k-card-actions>
</k-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	components: { },
	props: {
		user: { type: Object, required: true },
		warn_for_non_default_rights: { type: Boolean, required: false, default() { return false }},
		instance_requires_registration: { type: Boolean, required: false, default() { return false }},
		instance_uses_category_access: { type: Boolean, required: false, default() { return false }},
		instance_has_organizations: { type: Boolean, required: false, default() { return false }},
		instance_has_subdomains: { type: Boolean, required: false, default() { return false }},
	},
	data() { return {
		dialog_open: true,
		first_name: this.user.first_name,
		last_name: this.user.last_name,

		organization: this.user.organization,
		org_job_title: this.user.org_job_title,
		organization_type: this.user.organization_type,
		registration_reason: this.user.registration_reason,
		// convert category_access to array
		category_access: (this.user.category_access ? this.user.category_access.split(/\s*,\s*/) : ''),
		category_access_requested: this.user.category_access_requested,
		category_access_request_initial: this.user.category_access_requested,
		category_access_request_denied: this.user.category_access_request_denied || '',

		password: '',
		system_role: this.user.system_role,
		allow_to_create_frameworks_for_category: this.user.allow_to_create_frameworks_for_category,

		// keep this in sync with ExchangeRegister
		organization_types: [
			{ value: 'public_agency', text: 'Public agency (e.g. state DOE, country MOE, school, school district)' },
			{ value: 'non_public_agency', text: 'Non-public agency (e.g. charter school networks, nonprofit organizations)' },
			{ value: 'ed_tech_company', text: 'Ed-tech company (e.g. nonprofit organizations)' },
		],
	}},
	computed: {
		...mapState(['user_info', 'use_oidc_login', 'site_config']),
		...mapGetters(['viewing_subdomain', 'home_category']),
		new_user() { return empty(this.user.last_name) },
		system_role_options() {
			let arr = [
				{value:'admin', text: 'System Admin'},
				{value:'editor', text: 'System Editor'},
				{value:'reviewer', text: 'System Reviewer (view private)'},
				{value:'', text: 'System Default Rights (view public)'},
			]
			return arr
		},

		// THIS CAN BE DELETED
		// allow_to_create_frameworks: {
		// 	get() { return !empty(this.allow_to_create_frameworks_for_category) },
		// 	set(val) {
		// 		if (!val) this.allow_to_create_frameworks_for_category = ''
		// 		else this.allow_to_create_frameworks_for_category = this.home_category
		// 	}
		// },

		// keep this in sync with ExchangeRegister
		category_filter_items() {
			let category_records = U.create_category_records(this.$store.getters.filtered_framework_records, false, false)
			let arr = []
			arr.push({value: 'ALL', text: 'Paid standard plan (access to ALL frameworks)'})
			arr.push({value: 'CORE4', text: 'Paid Core-4 plan'})
			arr.push({value: 'TRIAL', text: 'Trial plan'})
			arr.push({value: '', text: '-----------------------------'})
			for (let cr of category_records) {
				if (empty(cr.map_label)) continue
				arr.push({
					value: cr.map_label,
					text: cr.title
				})
			}
			return arr
		},
		category_access_request_display() {
			if (empty(this.category_access_request_initial)) return ''
			let cr = this.category_filter_items.find(x=>x.value == this.category_access_request_initial)
			if (empty(cr)) {
				console.warn('couldn’t find category request')
				return ''
			}
			return `${cr.text} [${cr.value}]`
		},
		category_access_email_href() {
			if (this.category_access.length == 0) return ''

			let category_text = this.category_filter_items.find(x=>x.value == this.category_access[this.category_access.length-1]).text
			if (!category_text.includes) category_text += ' frameworks'
			let s = `mailto:${this.user.email}?`
				+ `cc=support@commongoodlt.com`
				+ `&subject=${this.site_config.app_name} Registration`
				+ `&body=You have been approved for registered access to ${category_text} frameworks from ${this.site_config.app_name}.`
				console.warn(s)
			return s
		},
	},
	created() {
		// this.system_role = this.user.system_role
	},
	mounted() {
		// DEBUG
		vapp.user_edit = this
	},
	methods: {
		show_help() { vapp.show_help('roles_system') },

		grant_category_access() {
			if (empty(this.category_access)) this.category_access = []
			// when we grant category access, we set category_access to include category_access_requested
			if (!this.category_access.includes(this.category_access_requested)) {
				this.category_access.push(this.category_access_requested)
			}
			// and clear category_access_requested
			this.category_access_requested = ''
			this.category_access_request_denied = ''
		},

		deny_category_access() {
			if (this.category_access_request_denied) return

			this.$confirm({
				title: 'Deny Access Request',
				text: sr(
					'Are you sure you want to deny the registration access request from <b>$1</b>?',
					this.user.email
				),
				acceptText: 'Deny Access',
				acceptColor: 'red',
				dialogMaxWidth: 600
			}).then(y=>{
				this.category_access_request_denied = 'yes'
			}).catch(n => {
				console.log(n)
			})
		},

		save_edits(flag) {
			// if this is a new user, a password must be specified, unless we're allowing for oidc_login
			if (!this.use_oidc_login) {
				this.password = $.trim(this.password)
				if (this.user.user_id == 0 && empty(this.password)) {
					this.$alert('You must set the password for a new user. Click the <i class="fas fa-shuffle"></i> button to generate a random password.<br><br><b>Note:</b> once the new user is created, a one-time sign-in link will be sent to the user via email, which will be valid for 24 hours. Clicking this link will sign the user in, after which they can change their password themselves.')
					return
				}
			}

			this.first_name = $.trim(this.first_name)
			this.last_name = $.trim(this.last_name)
			if (empty(this.first_name) || empty(this.last_name)) {
				this.$alert('You must specify the first and last name for the user.')
				return
			}

			if (this.warn_for_non_default_rights && flag != 'confirmed' && this.system_role != '') {
				let rl = U.capitalize_word(this.system_role)
				this.$confirm({
					title: 'Are you sure?',
					text: sr('Are you sure you want to give this new user system-level $1 rights? If you want to limit the user’s access to designated frameworks, you should give them System-level Default Rights.', rl),
					acceptText: sr('Grant $1 Rights', rl),
					dialogMaxWidth: 800
				}).then(y => {
					this.save_edits('confirmed')
				}).catch(n=>{console.log(n)}).finally(f=>{})
				return
			}

			this.allow_to_create_frameworks_for_category = $.trim(this.allow_to_create_frameworks_for_category)

			let payload = {
				user_id_being_edited: this.user.user_id,
				email: this.user.email,
				first_name: this.first_name,
				last_name: this.last_name,
				password: this.password,
				system_role: this.system_role || '*CLEAR*',
				allow_to_create_frameworks_for_category: this.allow_to_create_frameworks_for_category || '*CLEAR*',
				organization: this.organization || '*CLEAR*',
				org_job_title: this.org_job_title || '*CLEAR*',
				organization_type: this.organization_type || '*CLEAR*',
				category_access: (this.category_access.length == 0) ? '*CLEAR*' : this.category_access.join(','),
				category_access_requested: this.category_access_requested || '*CLEAR*',
				category_access_request_denied: this.category_access_request_denied || '*CLEAR*',
			}

			this.$emit('user_edited', payload)
		},

		cancel_clicked() {
			// if this was a new user, delete; otherwise just close the dialog
			if (this.user.user_id == 0) this.$emit('user_deleted')
			else this.$emit('editor_cancel')
		},

		generate_random_password() {
			let p = ''
			let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
			for (let i = 0; i < 12; ++i) {
				p += chars[U.random_int(chars.length)]
			}
			this.password = p
		},

		send_password_reset() {
			this.$confirm({
				title: 'One-Time Sign-In Link',
				text: 'Click the button below to send a one-time sign-in link to the user, which will be valid for 24 hours. This will allow the user to sign in to ' + this.$store.state.site_config.app_name + ' by clicking the link; then they can change their password themselves.',
				acceptText: 'Send One-Time Sign-In Link'
			}).then(y=>{
				// if sending token login link from here, don't add any extra message to the start of the email
				this.$emit('send_token_login', {user_email: this.user.email, body_html: ''})
			})
		},
	}
}
</script>

<style lang="scss">
</style>
